export var BASE_URL = {
    DEV: 'https://api.zzimkkong.com/api',
    PROD: 'https://k8s.zzimkkong.com/api',
};
